<template>
  <div class="mb-5 payWithBankTransfer">
    <div class="border border-left-0 border-right-0 border-top-0 ml-2 py-2">
      <div class="card-title d-flex align-items-center">
        <div class="d-flex align-items-center">
          <img
            :src="require('@/assets/images/payment/payment3.png')"
            class="mr-2"
            height="30"
          >
          <div class="">
            <h6 class="font-weight-semibold mb-0">
              <!-- {{ $t('_Plan.Bank Transfer') }} -->
              <!-- {{ $t('Bank Transfer (Available from 9:00 a.m. to 4:00 p.m.)') }} -->
              {{ $t('_Plan.Bank Transfer') }}
              <!-- {{ $t('Bank Transfer (Available from 9:00 a.m. to 4:00 p.m.)') }} -->
            </h6>
            <span class="text-grey-300">
              <i class="fa-solid fa-circle-info" />
              {{ $t('The system will take approximately 1 business day to verify the payment. Once confirmed, the order will be effective immediately.') }}
            </span>
          </div>
          
        </div>
        <!-- <span class="badge mr-2 step-num">5</span>{{ $t("_newWallet.Pay") }} -->
      </div>
    </div>
    <div class="card-body mt-3">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <h6>{{ $t("Bank Account Information") }}</h6>
              <div class="row">
                <div class="col-md-4">
                  <p>{{ $t("Bank") }}:</p>
                </div>
                <div class="col-md-6">
                  <img
                    class="mr-1"
                    height="25px"
                    :src="$storeIndex.getImageSrc('payment/Kbank_payment_logo')"
                    alt=""
                  >
                  <span style="color: #666">
                    {{ orderData.payment_info.bank_name }}
                  </span>
                </div>
                <div class="col-md-4">
                  <p>{{ $t("Account Number") }}:</p>
                </div>
                <div class="col-md-6">
                  <p style="color: #666">
                    {{ orderData.payment_info.account_number }}
                  </p>
                </div>
                <div class="col-md-4">
                  <p>{{ $t("Account Name") }}:</p>
                </div>
                <div class="col-md-6">
                  <p style="color: #666">
                    {{ orderData.payment_info.account_name }}
                  </p>
                </div>
                <div class="col-md-4">
                  <p>{{ $t("Amount") }}</p>
                </div>
                <div class="col-md-6">
                  <p style="color: #666">
                    ฿{{ orderData.pay_total | formatNumber }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>
                  {{ $t("Amount") }} <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  ref="amount"
                  step="0.01"
                  v-model="bankTransferForm.bank_amount"
                  :placeholder="$t('Enter amount...')"
                  class="form-control"
                >
                <label
                  v-if="submitted_formDeposit && !$v.bankTransferForm.bank_amount.required"
                  class="validation-invalid-label"
                >
                  {{ $t("Please enter amount") }}
                </label>
              </div>
              <div class="form-group mb-0">
                <div class="form-group">
                  <label>{{ $t("_AccountSetting.Upload Image") }}</label>
                  <vue-upload-multiple-image
                    :multiple="false"
                    :show-primary="false"
                    :max-image="limitImage"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @edit-image="editImage"
                    id-upload="myIdUpload"
                    edit-upload="myIdEdit"
                    :drag-text="$t('Drag Images')"
                    :browse-text="$t('Browse Image')"
                    primary-text="Base image"
                    mark-is-primary-text="Set base image"
                    popup-text="default base image"
                    :drop-text="$t('Drag and drop')"
                    :class="[submitted_formDeposit && !$v.bankTransferForm.media.required ? 'border-1 border-danger border-dashed' : '',]"
                  />
                  <input
                    type="hidden"
                    class="form-control"
                    name="media"
                    v-model="bankTransferForm.media"
                    :class="{
                      'is-invalid':
                        submitted_formDeposit &&
                        $v.bankTransferForm.media.$error,
                    }"
                  >
                  <label
                    v-if="submitted_formDeposit && !$v.bankTransferForm.media.required"
                    class="validation-invalid-label"
                  >
                    {{ $t("Please enter images") }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer fixed-bottom bg-light shadow">
      <div class="text-center">
        <ladda
          :text="$t('Confirm')"
          :btn-class="'btn-primary mr-2'"
          icon="<i class='fas fa-check-circle'></i>"
          :loading="loading"
          @click="updatePayment()"
          :disabled="checkingSlip"
        />
        <button
          type="button"
          class="btn btn-light"
          @click="cancel"
        >
          {{ $t("Cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service.js";
import CentralApi from "@/services/endpoint/central.service.js";
import numeral from "numeral";
import { required } from "vuelidate/lib/validators";
import VueUploadMultipleImage from "@/plugins/VueUploadMultipleImage.vue";
import Ladda from "@/plugins/Ladda.vue";

export default {
  props: {
    payAmount: {
      type: [Number, String],
      default: 0
    },
    orderData: {
      type: [Array, Object],
      default: null
    },
    paymentModule: {
      type: [Array, Object, String],
      default: null
    },
    isAddPayment: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueUploadMultipleImage,
    Ladda,
  },
  data() {
    return {
      loading: false,
      bankTransferForm: {
        bank_amount: this.orderData.pay_total.toFixed(2),
        bank_account_transferor: "",
        media: [],
      },
      limitImage: 1,
      limitImageSize: 1,
      submitted_formDeposit: false,
      checkingSlip: false,
    };
  },
  methods: {
    async uploadImageSuccess(formData, index, fileList, fileSize) {
      $(".image-container").css("margin-right", "0px");
      let imgSize = fileSize / 1000000;
      let imgList = fileList;
      if (index >= this.limitImage || imgSize > this.limitImageSize) {
        imgList.splice(index, 1);
        const self = this.$parent;
        self.$parent.$refs.toastr.Add({
          msg: this.mutedMaxUploadImg,
          title: "Warning",
          name: "msg",
          clickClose: true,
          timeout: 8000,
          position: "toast-top-right",
          type: "warning",
        });
      } else {
        var params = {
          file: fileList[0].path,
        };
        this.checkingSlip = true;
        try {
          let response = await Api.AiSlip.postAiSlip(params);
          if (response.data.gcvApiStatus) {
            if (response.data.data.amount) {
              let data = response.data.data;
              this.bankTransferForm.bank_amount = data.amount;
            } else {
              this.$swal.fire({
                title: this.$t("Cannot Detect") + " !",
                icon: "warning",
                iconColor: "#FF7043",
                html: this.$t("Please check your payment slip."),
                confirmButtonText: this.$t("OK"),
                buttonsStyling: false,
                customClass: {
                  confirmButton: "btn btn-primary",
                  cancelButton: "btn btn-light",
                },
                focusConfirm: false,
              });
            }
          } else {
            this.$swal.fire({
              title: this.$t("Cannot Detect") + " !",
              icon: "warning",
              iconColor: "#FF7043",
              html: this.$t("AI service is not ready to use."),
              confirmButtonText: this.$t("OK"),
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-light",
              },
              focusConfirm: false,
            });
            this.sales_order_payment.paid_date =
              moment().format("YYYY-MM-DD HH:mm");
          }
        } catch (error) {
          this.$toastr.e(
            this.$t("Please upload other image or contact the staff"),
            "<span class='icon-blocked'></span>" + this.$t("Error")
          );
        }
      }

      this.images = imgList;
      if (this.images) {
        this.bankTransferForm.media.push(this.images[0].path);
        // this.$parent.orders.order_payment.file =
        //   this.bankTransferForm.media[0].path;
      }
      this.checkingSlip = false;
    },
    async beforeRemove(index, done, fileList) {
      // done();
      // this.bankTransferForm.media = "";
      await this.$storeIndex.confirmRemoveFile(this, index, done, fileList)
    },
    callBackRemoveFile(status, index, done, fileList){
      if(status){
        done();
        this.images = "";
      } else {}
    },
    editImage(formData, index, fileList) {
      this.images = fileList;
    },
    cancel() {
      this.$parent.showBankTransfer = false;
      this.$parent.closeModal();
    },
    async purchaseShippingCreditPayWithBank() {
      this.loading = true;
      this.submitted_formDeposit = true;
      if (!this.$v.bankTransferForm.$invalid) {
        this.$parent.orders.order_payment.paid = this.bankTransferForm.bank_amount;

        let permission = "my_account_premium_change";
        if (this.$parent.action === "renew") {
          permission = "my_account_premium_renew";
        } else {
          permission = "my_account_premium_change";
        }
        let hasPermission = await Api.Permission.postHasPermission(permission);
        if (!hasPermission.data.status) {
          this.submitPermission(permission);
          return;
        }
        var self = this;
        self.$parent.setupBillingAddress();
        setTimeout(async function(){
          await CentralApi.Billing.postOrder(self.$parent.orders)
          .then((res) => {
            self.$toastr.s(
              self.$t(
                "Premium subscription success. Please wait for confirmation."
              ),
              "<span class='t-icon icon-checkmark3'></span>" +
                self.$t("Success")
            );
            self.$parent.$parent.feedData();
            self.$parent.closeModal();
            self.$router.push({
              name: "t.a.premium.subscriptions",
            });
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data.message ==
                "There is an order waiting for admin approval."
            ) {
              self.submitFailPendingOrder();
            } else {
              self.$toastr.w(
                self.$t(error.response.data.message),
                "<span class='icon-warning22'></span>" + self.$t("Warning")
              );
            }
          });
        }, 150);
      }
      this.loading = false;
    },
    async submitPermission(permission) {
      this.loading = true;
      var self = this;
      this.$swal({
        icon: "warning",
        iconColor: "#FF7043",
        title: this.$t("Access Denied"),
        // text: "You won’t be able to undo this action.",
        html: this.$t("You do not have permission to access this page."),
        showCancelButton: true,
        confirmButtonText:
          '<i class="fas fa-check-circle mr-1"></i>' + this.$t("Try again"),
        buttonsStyling: false,
        showCancelButton: true,
        cancelButtonText: this.$t("Cancel"),
        customClass: {
          confirmButton: "btn btn-primary mr-2",
          cancelButton: "btn btn-light",
        },
        focusConfirm: false,
        preConfirm: async function () {
          return await Api.Permission.postHasPermission(permission)
            .then(async (response) => {
              let hasPermission = response.data.status;
              if (hasPermission) {
                self.$parent.setupBillingAddress();
                setTimeout(async function(){
                  await CentralApi.Billing.postOrder(self.$parent.orders)
                  .then((res) => {
                    self.$toastr.s(
                      self.$t(
                        "Premium subscription success. Please wait for confirmation."
                      ),
                      "<span class='t-icon icon-checkmark3'></span>" +
                        self.$t("Success")
                    );
                    self.$parent.$parent.feedData();
                    self.$parent.closeModal();
                    self.$router.push({
                      name: "t.a.premium.subscriptions",
                    });
                    self.$swal.close();
                  })
                  .catch((error) => {
                    if (
                      error.response &&
                      error.response.data.message ==
                        "There is an order waiting for admin approval."
                    ) {
                      self.submitFailPendingOrder();
                    } else {
                      self.$toastr.w(
                        self.$t(error.response.data.message),
                        "<span class='icon-warning22'></span>" +
                          self.$t("Warning")
                      );
                      self.$parent.$parent.feedData();
                      self.$parent.closeModal();
                      self.$router.push({
                        name: "t.a.premium.subscriptions",
                      });
                      self.$swal.close();
                    }
                  });
                }, 150);
              } else {
                self.$swal.showValidationMessage(self.$t("Access Denied"));
              }
            })
            .catch((error) => {
              console.log("error", error);
              if (error) {
                self.$swal.showValidationMessage(self.$t("Access Denied"));
              }
            });
        },
      });
      this.loading = false;
    },
    submitFailPendingOrder() {
      this.$swal({
        icon: "warning",
        iconColor: "#FF7043",
        title: this.$t("Found pending order"),
        // text: "You won’t be able to undo this action.",
        html: this.$t("There is an order waiting for admin approval."),
        showCancelButton: true,
        confirmButtonText:
          '<i class="fas fa-check-circle mr-1"></i>' + this.$t("Confirm"),
        buttonsStyling: false,
        showCancelButton: false,
        customClass: {
          confirmButton: "btn btn-primary mr-2",
          cancelButton: "btn btn-light",
        },
        focusConfirm: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$parent.$parent.feedData();
          this.$parent.closeModal();
          this.$router.push({
            name: "t.a.premium.subscriptions",
          });
          this.$toastr.e(
            this.$t("Purchase Plan Failed."),
            "<span class='icon-blocked'></span>" + this.$t("Failed")
          );
          //   this.submitted_formDeposit = false;
          //   this.bankTransferForm.bank_amount = "";
          //   this.$parent.paymentMethod = "p4";
          //   $(".image-delete").click();
          //   this.cancel();
          //   this.$parent.closeModal();
        }
      });
    },
    async updatePayment(){
      try {
        this.submitted_formDeposit = true;
        let payload = {
          payment_method:this.orderData.payment_method,
          reference: this.orderData.reference,
          billing_reference: this.orderData.billing_reference,
          bank: this.orderData.payment_info.bank_code,
          bank_account_number: this.orderData.payment_info.account_number,
          amount: Number(this.bankTransferForm.bank_amount),
          attachments: this.bankTransferForm.media
        };
        if (!this.$v.bankTransferForm.$invalid) {
          this.loading = true;
          let response = this.paymentModule == "ShippingCredit" ? await Api.ShippingCredit.postPayment(this.orderData.id,payload) : await Api.SubscriptionV2.postPayment(this.orderData.id,payload);
          if (response.status != 200 && response.status != 201) {
            throw response;
          }
          this.$toastr.s(this.$t("Purchase Plan Success."),"<span class='fa-sharp fa-solid fa-circle-check'></span>" + this.$t("Success"));
          this.loading = false;
          if(this.isAddPayment){
            this.$parent.$parent.setParams(this.$parent.$parent.filter);
          }
          
          this.$parent.closeModal();
        }
      } catch (error) {
        console.log('error',error)
        if (error.data.message && error.data.message == "There is an order waiting for admin approval.") {
          this.submitFailPendingOrder();
          this.loading = false;
        } else {
          this.$toastr.w(this.$t("Purchase Plan Failed."),"<span class='fa-solid fa-circle-check mr-2'></span>" + this.$t("Failed"));
          this.loading = false;
        }
      }
    },
  },
  watch: {},
  filters: {
    formatNumber: function (value) {
      return numeral(value).format("0,0.00");
    },
  },
  validations: {
    bankTransferForm: {
      bank_amount: {
        required,
      },
      media: {
        required,
      },
    },
  },
};
</script>

<style scoped>
.step-num {
  height: 24px;
  width: 24px;
  font-weight: normal;
  text-align: center;
  padding: 0;
  line-height: 24px;
  background: #333;
  color: #fff;
  border-radius: 100%;
}

ol li {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/account-setting/PayWithBankTransfer.vue